import { SHARED_ASSET_PATH, ImageFormat, BRANDED_ASSET_PATH } from '@bg-shared';

export const buildUrl = (
    category: string,
    filename: string,
    size: number,
    format: ImageFormat,
    brandName?: string,
): string =>
    `/static/${
        brandName ? `${BRANDED_ASSET_PATH}/${brandName}` : SHARED_ASSET_PATH
    }/images/${category}/${filename}-${size}.${format}`;
